export default __webpack_public_path__ + "static/media/image_2.c88ec9ea.jpg";